import { Button } from "PFComponents/button";
import i18n from "PFCore/i18n";
import PropTypes from "prop-types";
import React from "react";

const ShowMore = ({ currentPage, totalPages, onClick, title }) => {
  const morePages = currentPage !== totalPages;
  return (
    morePages && (
      <Button kind="secondary" onClick={onClick}>
        {title}
      </Button>
    )
  );
};

export default ShowMore;

ShowMore.defaultProps = {
  title: i18n.t("profiles:list.showMore")
};

ShowMore.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string
};
